import styles from "./styles.module.scss";
import { Box as MantineBox } from "@mantine/core";

type GhostCardProps = {
  small?: boolean;
  fixed?: boolean;
  imageOnly?: boolean;
  index: number;
};

const GhostItemCard = ({
  small = false,
  fixed = false,
  imageOnly = false,
  index,
}: GhostCardProps) => {
  return (
    <MantineBox
      className={styles.ghostCard}
      data-smallmobile={small}
      data-fixed={fixed}
      data-image-only={imageOnly || undefined}
      data-even={index % 2 === 0}
    >
      <MantineBox
        className={small || fixed ? styles.imageContainerPlaceholder : styles.imagePlaceholder}
      />
      <MantineBox className={styles.body}>
        <MantineBox className={styles.text}>
          <MantineBox className={styles.brandBar}>
            <MantineBox className={styles.brandPlaceholder} />
          </MantineBox>
          <MantineBox className={styles.titlePlaceholder} />
          <MantineBox className={styles.sizePlaceholder} />
          <MantineBox className={styles.priceBar}>
            <MantineBox className={styles.vendorPlaceholder} />
            <MantineBox className={styles.priceColumn}>
              <MantineBox className={styles.pricePlaceholder} />
              <MantineBox className={styles.timePlaceholder} />
            </MantineBox>
          </MantineBox>
        </MantineBox>
      </MantineBox>
    </MantineBox>
  );
};

export default GhostItemCard;
